import { v4 as uuidv4 } from 'uuid';

// Queue all batches upfront and create batch IDs
export const queueAllBatches = (files: string[], updateProjectFileBatchIds: any) => {
    const batches = [];
    let currentIndex = 0;

    // First batch with 5 files
    if (files.length > 0) {
        const firstBatch = files.slice(0, Math.min(5, files.length));
        const batchId = uuidv4();
        batches.push({ batchId, files: firstBatch });
        updateProjectFileBatchIds(batchId, "add");
        currentIndex = firstBatch.length;
    }

    // Remaining batches with 25 files each
    while (currentIndex < files.length) {
        const batch = files.slice(currentIndex, currentIndex + 25);
        const batchId = uuidv4();
        batches.push({ batchId, files: batch });
        updateProjectFileBatchIds(batchId, "add");
        currentIndex += batch.length;
    }

    return batches;
};

